module.exports = __webpack_public_path__ + "img/logo-autopay.3488e6bb.svg";